// extracted by mini-css-extract-plugin
module.exports = {"container":"FilterTag_container__jSrVo","filter":"FilterTag_filter__rodD3","closeIcon":"FilterTag_closeIcon__Ud7ZE","filterClearAll":"FilterTag_filterClearAll__M7yip"};